import { render, staticRenderFns } from "./TrafficLight.vue?vue&type=template&id=14a09442&scoped=true&"
import script from "./TrafficLight.vue?vue&type=script&lang=ts&"
export * from "./TrafficLight.vue?vue&type=script&lang=ts&"
import style0 from "./TrafficLight.vue?vue&type=style&index=0&id=14a09442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a09442",
  null
  
)

export default component.exports